import buildQuery from "odata-query";
import globalAxios from "axios";
import {
  BaseAdministrativeOffice,
  BaseAdministrativeOfficesApiFactory,
  BaseInstitution,
  BaseInstitutionsApiFactory,
  BaseProfessional,
  BaseProfessionalsApiFactory,
} from "@/generated";
import {
  WechatPhysiciansApiFactory,
} from "@/generated/api/wechat-physicians-api";
import { WechatPhysician } from "@/generated/models/wechat-physician";
import { PaginationParams } from "@/type/api";
import { genOdataQueryPageOptions } from "@/utils/odata";

// 公众号授权 token 获取
export const weChatAuth  = async (code: any) => {
  const url = "/api/login/WeChatAuth";
  const res = await globalAxios.get(url, { params: { code} });
  const token = res.data?.data?.token;
  const seed = res.data?.data?.seed;
  if (token) {
    localStorage.setItem("token", token);
    localStorage.setItem("seed", seed);
  }
  return res
};

// 获取微信OpenId
export const getWechatOpenId = async (code: any) => {
  const res = await weChatAuth(code);
  return res?.data?.data?.user?.openid as string;
  // const url = "/api/webmeetingapi/api/WeChat/GetOpenId";
  // const res = await globalAxios.get(url, { params: { code } });
  // return res.data?.data?.openid as string;
};

// 签约处获取验证码
export const getVerificationCode = async (data: any) => {
  const url = "/api/webmeetingapi/api/WeChat/Get";
  const method = "GET";
  return globalAxios.get(url, { params: { phone: data } });
};
// 注册留资获取验证码
export const getRegisterVerifyCode = async (data: any) => {
  const url = "/api/webmeetingapi/api/WeChat/GetRegisterVerifyCode";
  const method = "GET";
  return globalAxios.get(url, { params: { phone: data } });
};
// 提交 公众号注册留资
export const createUser = async (data: any) => {
  const url = "/api/webmeetingapi/api/WeChat/Register";
  return await globalAxios.post(url, data);
};
// 编辑 公众号修改注册留资信息
export const UpDateUser = async (data: Partial<WechatPhysician>) => {
  const url = "/api/webmeetingapi/api/WeChat/RegisterModify";
  return await globalAxios.post(url, data);
};
// 获取医院base
export const fetchHospital = async (
  filter?: any,
  paginationParams?: PaginationParams
) => {
  const res = await BaseInstitutionsApiFactory().get({
    odata: { filter, ...genOdataQueryPageOptions(paginationParams) },
  });
  return res.data as any as BaseInstitution[];
};
// 获取科室base
export const fetchOffices = async (
  filter?: any,
  paginationParams?: PaginationParams
) => {
  const res = await BaseAdministrativeOfficesApiFactory().get({
    odata: { filter, ...genOdataQueryPageOptions(paginationParams) },
  });
  return res.data as any as BaseAdministrativeOffice[];
};
// 获取微信留资表
export const queryUser = async (wx_open_id: string) => {
  const url = `/api/standard/OData/PhysicianWechats?$filter=wx_open_id eq '${wx_open_id}'`;
  const res: any = await globalAxios.get(url);
  return res.data[0];
  // const filter = { wechat_open_id, channel: "公众号" };
  // console.info('------------')
  // const res = await WechatPhysiciansApiFactory().get({
  //   odata: buildQuery({ filter }),
  // });
  // return res.data?.[0] as any as WechatPhysician;
};

// 获取微信留资列表
export const fetchWechatPhysicianList = async (filter: object) => {
  const res = await WechatPhysiciansApiFactory().get({
    odata: { filter },
  });
  return res.data as any as WechatPhysician[];
};

// 签合同
export const confirmInvitation = async (data: any) => {
  const url = "/api/webmeetingapi/api/WeChat/ConfirmInvitation";
  const method = "POST";
  return globalAxios.post(url, data);
};

// 接受拒绝邀请
export const confirmInvite = async (data: any) => {
  const url = "/api/webmeetingapi/api/WeChat/Confirm";
  const method = "POST";
  return globalAxios.post(url, data);
};

// 用户会议
export const getUserMeetingList = async (
  filter?: { open_id?: string; },
  {
    recent,
  }: {
    recent?: boolean;
  } = {}
) => {
  let url: string;
  if (recent) {
    url = `/api/webmeetingapi/api/WeChatMeeting/GetHCPMeetingNearFuture?open_id=${filter?.open_id}`;
  } else {
    url = `/api/webmeetingapi/api/WeChatMeeting/GetHCPMeetingHistory?open_id=${filter?.open_id}`;
  }

  const res = await globalAxios.get(url);
  return res;
};
// 用户会议历史
export const GetHCPMeetingHistory = async (pageObj: any, data: any) => {
  let url: string;

  let filter = '';
  if (data.meeting_name) {
    filter += `&meeting_name=${data.meeting_name}`;
  }
  if (data.date_start) {
    filter += `&date_start=${data.date_start}`;
  }
  if (data.date_end) {
    filter += `&date_end=${data.date_end}`;
  }
  url = `/api/webmeetingapi/api/WeChatMeeting/GetHCPMeetingHistory?open_id=${data.wechat_open_id}&page_size=${pageObj.pageSize}&page_index=${pageObj.current}${filter}`;

  const res = await globalAxios.get(url);
  return res.data.data;
};

// 查看用户是否签署同意书
export const getIsConcent = (params: {
  wx_open_id: string,
  physician_id: string
}) => {
  const url = '/api/webmeetingapi/api/WeChat/GetIsConcent'
  return globalAxios.get(url, { params }).then(res => res.data.data as { is_concent: string, concent_time: string })
}

// 签署知情同意书
export const signConcent = (wx_open_id: string) => {
  const url = '/api/webmeetingapi/api/WeChat/Concent'
  return globalAxios.post(url, {
    wx_open_id
  })
}